// 1开头 11位数字
export const phone = /^1\d{10}$/

// 8-16位字母、数字或字符,至少包含两种
export const pass = /^(?![0-9]+$)(?![a-zA-Z]+$)(?![A-Za-z]+$)(?![_]+$)[0-9_A-Za-z]{8,16}$/

// 邮箱
export const email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
